import { About } from '~/models/about';

export const aboutService = {
	fetch: async (): Promise<About.Model | null> => {
		const params = {
			fields: ['*', 'employees.*', 'employees.photo.*', 'form.*'],
		};

		try {
			const response = await $fetch<About.Model>(About.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch About:', error);

			return null;
		}
	},
};
